import React, { useState, useEffect } from "react";
import "./App.css";

export default function Home() {
    const [data, setData] = useState();
    // const [load, setLoad] = useState(false);

    useEffect(() => {
        getCoordinate();
    }, []);
    const getCoordinate = async () => {
        console.log("get coordinate called");
        if ("geolocation" in navigator) {   
            console.log("if called");
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = JSON.stringify(position.coords.latitude);
                    const lng = JSON.stringify(position.coords.longitude);
                    //   console.log(lat);
                    getWeather(lat, lng);
                },
                (error) => alert(error.message),
                { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
            );
        } else {
            // notificationElement.style.display = "block";
            // notificationElement.innerHTML = "<p>Browser Does'nt Support GeoLocation.</p>";
        }
    };
    // https://samples.openweathermap.org/data/2.5/forecast?lat=35&lon=139&appid=439d4b804bc8187953eb36d2a8c26a02

    async function getWeather(latitude, longitude) {
        const response = await fetch(
            `https://api.openweathermap.org/data/2.5/forecast?lat=${latitude}&lon=${longitude}&appid=a8776030970a49477b7cbdeb2cd6754d&units=metric`
        );
        const data = await response.json();
        console.log(data);
        setData(data);
        // setLoad(true);
    }
    if (data) {
        return (
            <>
                
                <div className="main-container">
                    <div className="city">
                        <h2 className="city-name">
                            <span>{data.city['name']}</span>
                            <sup>{data.city.country}</sup>

                            {/* {console.log("data.name" + JSON.stringify(data.main.temp))} */}

                            {/* {console.log("data.main.temp" + JSON.stringify(data))} */}
                        </h2>
                        <p>Population:  {data.city.population}</p>
                        <div className="city-temp">
                            {Math.round(data.list[0]['main']['temp'])}
                            <sup>&deg;C</sup>
                        </div>
                        <div className="info">
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data.list[0]['weather'][0].icon}@2x.png`} alt={data.list[0]['weather'][0].description} />
                            <h3><b>{data.list[0]['weather'][0].description}</b></h3>
                            <h4>Min Temp: <b> {Math.round(data.list[0]['main']['temp_min'])}&deg;C</b></h4>
                            <h4>Max Temp: <b> {Math.round(data.list[0]['main']['temp_max'])}&deg;C</b></h4>
                            <h4>Humidity: <b> {Math.round(data.list[0]['main']['humidity'])}%</b></h4>
                            <h4>Wind Speed: <b> {Math.round(data.list[0]['wind']['speed'])} Km/h</b></h4>
                            <hr /><hr />
                        </div>
                        <div id="firstday">
                            <span><b>{data['list'][1].dt_txt.substr(10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data.list[1]['weather'][0].icon}@2x.png`} alt={data.list[0]['weather'][0].description} />
                            <h4>{Math.round(data.list[1]['main']['temp'])}&deg;C</h4>
                            <span><b>{data['list'][2].dt_txt.substr(10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data.list[2]['weather'][0].icon}@2x.png`} alt={data.list[0]['weather'][0].description} />
                            <h4>{Math.round(data.list[2]['main']['temp'])}&deg;C</h4>
                            <span><b>{data['list'][3].dt_txt.substr(10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data.list[3]['weather'][0].icon}@2x.png`} alt={data.list[0]['weather'][0].description} />
                            <h4>{Math.round(data.list[3]['main']['temp'])}&deg;C</h4>
                            <span><b>{data['list'][4].dt_txt.substr(10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data.list[4]['weather'][0].icon}@2x.png`} alt={data.list[0]['weather'][0].description} />
                            <h4>{Math.round(data.list[4]['main']['temp'])}&deg;C</h4>                                            

                        </div>
                        <div className="oneday">
                            <span><b>{data['list'][9].dt_txt.substr(0, 10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data['list'][9]['weather'][0].icon}@2x.png`} />
                            <p>{Math.round(data['list'][9]['main']['temp'])}&deg;C<br />
                                {data['list'][9]['weather'][0]['description']}</p>
                        </div><br />
                        <div className="oneday">
                            <span><b>{data['list'][13].dt_txt.substr(0, 10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data['list'][13]['weather'][0].icon}@2x.png`} />
                            <p>{Math.round(data['list'][13]['main']['temp'])}&deg;C<br />
                                {data['list'][13]['weather'][0]['description']}</p>
                        </div><br />
                        <div className="oneday">
                            <span><b>{data['list'][21].dt_txt.substr(0, 10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data['list'][21]['weather'][0].icon}@2x.png`} />
                            <p>{Math.round(data['list'][21]['main']['temp'])}&deg;C<br />
                                {data['list'][21]['weather'][0]['description']}</p>
                        </div><br />
                        <div className="oneday">
                            <span><b>{data['list'][29].dt_txt.substr(0, 10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data['list'][29]['weather'][0].icon}@2x.png`} />
                            <p>{Math.round(data['list'][29]['main']['temp'])}&deg;C<br />
                                {data['list'][29]['weather'][0]['description']}</p>
                        </div><br />
                        <div className="oneday">
                            <span><b>{data['list'][37].dt_txt.substr(0, 10)}</b></span>
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${data['list'][37]['weather'][0].icon}@2x.png`} />
                            <p>{Math.round(data['list'][37]['main']['temp'])}&deg;C<br />
                                {data['list'][37]['weather'][0]['description']}</p>
                        </div><br />

                    </div>
                    <a href="#top">Go To Top &#9757;</a>
                </div>
            </>
        );
    } else {
        return (
            <>
                <h1 id="loading">Loading...</h1>
                <p id="interne">You Need to allow location permission in order to access the Weather App</p>
                <p id="interne">if it is taking too much time than Check your internet Connection</p>
                <div id="loader">
                </div>
            </>
        );
    }
}

